import * as React from "react";

import { addDays, format, startOfWeek } from "date-fns";

import { TableRow, TableHeaderCell } from "simplydo/react/ui/table";

/** Return array of week day names.
 *
 * getWeekDays() --> ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Su']
 */
const getWeekDays = (localization?: string) => {
  const weekDays: string[] = [];
  let day = startOfWeek(new Date());
  for (let i = 0; i < 7; i++) {
    weekDays[i] = format(day, "EE");
    day = addDays(day, 1);
  }

  return weekDays;
};

const cellStyle = {
  border: "none",
  borderBottom: "1px solid rgba(34,36,38,.1)",
};

const getWeekDayCells = (localization?: string) =>
  getWeekDays(localization).map((weekDay) => (
    <TableHeaderCell key={weekDay} style={cellStyle} colSpan={1}>
      {weekDay}
    </TableHeaderCell>
  ));

export interface HeaderWeeksProps {
  /** Moment date localization */
  localization?: string;
}

function HeaderWeeks(props: HeaderWeeksProps) {
  const { localization } = props;

  return <TableRow>{getWeekDayCells(localization)}</TableRow>;
}

export default HeaderWeeks;
